import { ScanLineItemOptimized } from '@kaiizen/kai-scan-template-system';
import { GroupedReportLineItems } from '../ScopeReportTypes';

/**
 * Filters sowData to only include deferred items
 */
export const filterDeferredGroups = (sowData: GroupedReportLineItems): GroupedReportLineItems => {
  const filtered: GroupedReportLineItems = {};
  Object.entries(sowData).forEach(([key, items]) => {
    const deferredItems = items.filter(item => item.isDeferredLineItem === true);
    if (deferredItems.length > 0) {
      filtered[key] = deferredItems;
    }
  });
  return filtered;
};

export const filterDeferredLineItem = (lineItem: ScanLineItemOptimized): boolean => {
  return lineItem.tags?.deferred === true;
};
